export const shortenedMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Uppercase 3-letter months for Kalshi-style ticker suffixes (e.g. `26FEB09`). */
export const shortenedMonthsUpper = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
] as const;

export const shortenedDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;

// Use getter functions to ensure values are computed at runtime, not build time
// This ensures deterministic bundle hashing across builds
export const getCurrentYear = (): number => new Date().getFullYear();
export const getCurrentMonthShort = (): string => shortenedMonths[new Date().getMonth()];

export const SECOND_IN_MS = 1000;
export const MINUTE_IN_MS = 60 * SECOND_IN_MS;
export const HOUR_IN_MS = 60 * MINUTE_IN_MS;
export const DAY_IN_MS = 24 * HOUR_IN_MS;
